/**
 * Unified Templates Gallery (UTG) taxonomy categories share the
 * `taxonomyTemplateCategory` content type with the legacy categories.
 * The loader writes their internal name as `UTG - <name>`, and that
 * internal name is the only signal. The legacy Confluence templates page
 * derives its category list from template links, so it must drop UTG
 * categories or they surface as search suggestions and resolvable
 * category pages.
 */
export const UTG_INTERNAL_NAME_PREFIX = 'UTG';

type CategoryWithInternalName = {
	categoryNameInternal?: string | null;
} | null;

export const isUtgTemplateCategory = (category: CategoryWithInternalName | undefined): boolean => {
	return category?.categoryNameInternal?.startsWith(UTG_INTERNAL_NAME_PREFIX) ?? false;
};
